// Resolves the plain-text content of whichever rich editor is currently mounted, used for the
// word-count/reading-time display in LocalDraftManager#getTextValue. Extracted so it can be
// unit-tested without stubbing jQuery/window (see local_draft_manager_text_value.test.mjs).
//
// TinyMCE and ProseMirror both support a `getContent({format: 'text'})` call that returns plain
// text. Editors without a text-format branch here (ACE, CodeEditor, Tiptap, plain inputs) fall
// back to `getValue()`, which for rich editors returns raw HTML — fine for plain-text inputs,
// but would overcount words from tags/attributes if used for a rich editor.
export function resolveTextValue({ tinymce, prosemirror, getValue }) {
  if (tinymce != null) {
    return tinymce.getContent({ format: 'text' })
  }
  if (prosemirror != null) {
    return prosemirror.getContent({ format: 'text' })
  }
  return getValue()
}
